const isAllowedToDoByKey = (key, action, allowedPermissions, isCountVisibility = true) => {
    const component = allowedPermissions[key];
    const componentRoutes = allowedPermissions[key]?.routes;
    const toLowerCaseAction = action.toLowerCase();
    let isComponent = true;

    if (isCountVisibility) {
        isComponent = allowedPermissions[key]?.isComponent;
    }

    if (component && isComponent && componentRoutes && componentRoutes.includes(toLowerCaseAction)) return true;
    return false;
};

const isAllowedToDo = (action, allowedPermissions) => {

    const toLowerCaseAction = action.toLowerCase();

    if (allowedPermissions.includes(toLowerCaseAction)) return true;
    return false;
};

export {
    isAllowedToDo,
    isAllowedToDoByKey,
};